import { PROJECT_TYPE } from './const';

export const isWtmProjectType = (projectType) => {
  return [PROJECT_TYPE.wtmHomePage, PROJECT_TYPE.continuousOptimization].includes(projectType);
};

export const isBlogPostProjectType = (projectType) => projectType === PROJECT_TYPE.blogPostBuilder;

export const isLongFormProjectType = (projectType) => projectType === PROJECT_TYPE.longFormBuilder;

export const isDocumentProjectType = (projectType) => {
  if (!projectType) {
    return false;
  }

  return (
    !isWtmProjectType(projectType) &&
    !isBlogPostProjectType(projectType) &&
    !isLongFormProjectType(projectType)
  );
};
